import { FC, PropsWithChildren } from "react";

const FAQNumberedItemContainer: FC<PropsWithChildren> = ({children}) => {
  return (
    <ol className="list-decimal pl-6">{children}</ol>
  )
}

const FAQBullettedItemContainer: FC<PropsWithChildren> = ({children}) => {
  return (
    <ul>{children}</ul>
  )
}

export const FAQItemList = ({data, numbered}) => {

  const contents = data.map((item, index) => {
    return (
      <li key={index}>{item}</li>
    )
  })

  if (numbered) {
    return (
      <FAQNumberedItemContainer>
        {contents}
      </FAQNumberedItemContainer>
    )
  }

  return (
    <FAQBullettedItemContainer>
      {contents}
    </FAQBullettedItemContainer>
  )
}